/* ============================================================
   REVOLOR Cart Drawer Upgrades – JS
   - Free Shipping Bar: dynamisches Update via /cart.js
   - Storefront API Cart: Discounts, Shipping, Totals, Checkout-URL
   ============================================================ */

(function () {
  'use strict';

  var THRESHOLD_CENTS_FALLBACK = 10000; // 100 € — nur falls data-attr fehlt

  /* -------------------------------------------------------
     SHIPPING PREVIEW (Shop-Metafield custom.cart_shipping_preview)
     Liquid rendert den Preis direkt aus dem Metafield und liefert
     ihn als data-shipping-flat-cents mit. KEINE Rate-API-Calls:
     /cart/prepare_shipping_rates.json persistierte die Probe-Adresse
     am Cart (Checkout-Prefill-Bug), GET /cart/shipping_rates.json
     ist unzuverlässig. Metafield-Wert = Cents (money-Typ direkt referenziert).
     ------------------------------------------------------- */
  function getFlatShippingCents(shippingRow) {
    var cents = parseInt(shippingRow.dataset.shippingFlatCents, 10);
    return !isNaN(cents) && cents > 0 ? cents : null;
  }

  /* -------------------------------------------------------
     FREE SHIPPING BAR
     ------------------------------------------------------- */
  function updateShippingBar(totalCents) {
    var bar = document.querySelector('.cdu-shipping');
    if (!bar) return;

    var thresholdCents = parseInt(bar.dataset.threshold, 10) || THRESHOLD_CENTS_FALLBACK;
    var pct = Math.min((totalCents / thresholdCents) * 100, 100);
    var remainingCents = Math.max(thresholdCents - totalCents, 0);
    var remainingEur = remainingCents / 100;
    var reached = remainingCents <= 0;

    var fill = bar.querySelector('.cdu-shipping__fill');
    if (fill) fill.style.width = pct + '%';

    if (reached) {
      bar.classList.add('cdu-shipping--reached');
    } else {
      bar.classList.remove('cdu-shipping--reached');
    }

    var textEl = bar.querySelector('.cdu-shipping__text');
    if (!textEl) return;

    if (reached) {
      textEl.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        'Kostenloser Versand freigeschaltet';
    } else {
      var formatted = remainingEur.toFixed(2).replace('.', ',');
      textEl.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        'Noch <span>' + formatted + ' &euro;</span> bis zum kostenlosen Versand';
    }
  }

  function initShippingBar() {
    var bar = document.querySelector('.cdu-shipping');
    if (!bar) return;
    var totalCents = parseInt(bar.dataset.cartTotal, 10) || 0;
    updateShippingBar(totalCents);
  }

  /* -------------------------------------------------------
     STOREFRONT CART — UI UPDATES
     ------------------------------------------------------- */
  function formatEur(amountStr) {
    var num = parseFloat(amountStr) || 0;
    return num.toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function sumDiscountAllocations(cart) {
    var total = 0;
    if (cart.discountAllocations) {
      for (var i = 0; i < cart.discountAllocations.length; i++) {
        total += parseFloat(cart.discountAllocations[i].discountedAmount.amount) || 0;
      }
    }
    if (total === 0 && cart.lines && cart.lines.edges) {
      for (var j = 0; j < cart.lines.edges.length; j++) {
        var line = cart.lines.edges[j].node;
        if (line.discountAllocations) {
          for (var k = 0; k < line.discountAllocations.length; k++) {
            total += parseFloat(line.discountAllocations[k].discountedAmount.amount) || 0;
          }
        }
      }
    }
    return total;
  }

  function getActiveDiscountCode(cart) {
    if (cart.discountCodes) {
      for (var i = 0; i < cart.discountCodes.length; i++) {
        if (cart.discountCodes[i].applicable) return cart.discountCodes[i].code;
      }
    }
    if (cart.discountAllocations) {
      for (var i = 0; i < cart.discountAllocations.length; i++) {
        if (cart.discountAllocations[i].code) return cart.discountAllocations[i].code;
      }
    }
    return null;
  }

  /* -------------------------------------------------------
     SHIPPING ROW — statische Vorschau aus Shop-Metafield (data-shipping-flat-cents)
     ------------------------------------------------------- */
  function initShippingRow() {
    var shippingRow = document.querySelector('.cdu-totals__shipping');
    var shippingEl = document.querySelector('[data-shipping-value]');
    var totalEl = document.querySelector('[data-total]');
    if (!shippingRow || !shippingEl || !totalEl) return;

    var subtotalCents = parseInt(totalEl.dataset.cartSubtotalCents, 10) || 0;
    var thresholdCents = parseInt(shippingRow.dataset.shippingThresholdCents, 10) || THRESHOLD_CENTS_FALLBACK;
    var flatCents = getFlatShippingCents(shippingRow);

    function render(state, priceCents) {
      shippingEl.className = '';
      if (state === 'free') {
        shippingEl.classList.add('cdu-totals__shipping-free');
        shippingEl.textContent = 'Kostenlos';
      } else if (state === 'unknown') {
        shippingEl.classList.add('cdu-totals__shipping-pending');
        shippingEl.textContent = 'Wird im Checkout berechnet';
      } else {
        shippingEl.textContent = formatEur((priceCents / 100).toString());
      }
      var addCents = state === 'paid' ? priceCents : 0;
      var totalCents = subtotalCents + addCents;
      if (totalCents < 0) totalCents = 0;
      totalEl.textContent = formatEur((totalCents / 100).toString());
    }

    if (subtotalCents >= thresholdCents) {
      render('free');
      return;
    }
    if (flatCents) {
      render('paid', flatCents);
      return;
    }
    render('unknown');
  }

  // Legacy-Storefront-GraphQL-Renderer bleibt für evtl. externe Aufrufer erhalten,
  // wird intern aber nicht mehr benutzt (siehe initShippingRow).
  function renderCartState(cart) {
    if (!cart) return;

    var subtotal = cart.cost && cart.cost.subtotalAmount ? parseFloat(cart.cost.subtotalAmount.amount) : 0;
    var discountTotal = sumDiscountAllocations(cart);
    var code = getActiveDiscountCode(cart);

    var subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl) {
      subtotalEl.textContent = formatEur(subtotal.toString());
    }

    var allDiscountRows = document.querySelectorAll('.cdu-totals__discount');
    var jsDiscountRow = document.querySelector('[data-discount-row]');

    if (code && discountTotal > 0) {
      if (jsDiscountRow) {
        jsDiscountRow.hidden = false;
        jsDiscountRow.style.display = '';
        var label = jsDiscountRow.querySelector('[data-discount-label]');
        var amount = jsDiscountRow.querySelector('[data-discount-amount]');
        if (label) {
          label.innerHTML = 'Rabattcode <span class="cdu-totals__code-tag">' + code + '</span>';
        }
        if (amount) amount.textContent = '-' + formatEur(discountTotal.toString());
      }
    } else {
      allDiscountRows.forEach(function (row) {
        row.hidden = true;
        row.style.display = 'none';
      });
    }

    var shippingRow = document.querySelector('.cdu-totals__shipping');
    var shippingEl = document.querySelector('[data-shipping-value]');
    var totalEl = document.querySelector('[data-total]');

    var effectiveTotal = subtotal - discountTotal;
    var thresholdCents = shippingRow
      ? parseInt(shippingRow.dataset.shippingThresholdCents, 10) || THRESHOLD_CENTS_FALLBACK
      : THRESHOLD_CENTS_FALLBACK;
    var reachedFreeShipping = Math.round(effectiveTotal * 100) >= thresholdCents;

    function renderShipping(state, valueText, cost) {
      if (shippingEl) {
        shippingEl.className = '';
        if (state === 'free') {
          shippingEl.classList.add('cdu-totals__shipping-free');
          shippingEl.textContent = 'Kostenlos';
        } else if (state === 'unknown') {
          shippingEl.classList.add('cdu-totals__shipping-pending');
          shippingEl.textContent = 'Wird im Checkout berechnet';
        } else {
          shippingEl.textContent = valueText;
        }
      }
      if (totalEl) {
        var addCost = state === 'free' ? 0 : (typeof cost === 'number' ? cost : 0);
        var computedTotal = effectiveTotal + addCost;
        if (computedTotal < 0) computedTotal = 0;
        totalEl.textContent = formatEur(computedTotal.toString());
      }
    }

    if (reachedFreeShipping) {
      renderShipping('free');
    } else if (!shippingRow) {
      // Kein Row-Element (leerer Cart o.ä.) — nichts zu tun.
    } else {
      var flatCents = getFlatShippingCents(shippingRow);
      if (flatCents) {
        renderShipping('paid', formatEur((flatCents / 100).toString()), flatCents / 100);
      } else {
        renderShipping('unknown');
      }
    }

    var checkoutLink = document.querySelector('[data-checkout-url]');
    if (checkoutLink && cart.checkoutUrl) {
      checkoutLink.href = cart.checkoutUrl;
    }

    if (cart.lines && cart.lines.edges) {
      cart.lines.edges.forEach(function (edge) {
        var line = edge.node;
        var variantId = line.merchandise && line.merchandise.id;
        if (!variantId) return;

        var numericId = variantId.replace('gid://shopify/ProductVariant/', '');
        var btn = document.querySelector('cart-drawer button[data-variant-id="' + numericId + '"]');
        var cartItem = btn ? btn.closest('.cart-item') : null;
        if (!cartItem) return;

        var lineDiscount = 0;
        if (line.discountAllocations) {
          line.discountAllocations.forEach(function (a) {
            lineDiscount += parseFloat(a.discountedAmount.amount) || 0;
          });
        }

        var originalPrice = line.merchandise.price ? parseFloat(line.merchandise.price.amount) * line.quantity : 0;
        var priceEl = cartItem.querySelector('.cart-item__details .cart-item__price, .cart-item__details .cart-item__discounted-prices');
        if (!priceEl) return;

        if (lineDiscount > 0) {
          var finalPrice = Math.max(originalPrice - lineDiscount, 0);
          priceEl.setAttribute('data-sf-updated', '1');
          priceEl.className = 'cart-item__discounted-prices';
          priceEl.innerHTML =
            '<span class="cart-item__final-price">' + formatEur(finalPrice.toString()) + '</span>' +
            '<span class="cart-item__old-price">' + formatEur(originalPrice.toString()) + '</span>';
        } else if (priceEl.hasAttribute('data-sf-updated')) {
          priceEl.removeAttribute('data-sf-updated');
          priceEl.className = 'cart-item__price';
          priceEl.textContent = formatEur(originalPrice.toString());
        }
      });
    }

    var barCents = Math.round((subtotal - discountTotal) * 100);
    if (barCents < 0) barCents = 0;
    updateShippingBar(barCents);
  }

  /* -------------------------------------------------------
     DISCOUNT CODE UI — Event Delegation
     ------------------------------------------------------- */
  var _discountBusy = false;

  function $disc(sel) { return document.querySelector('cart-drawer ' + sel); }

  function discSetLoading(on) {
    _discountBusy = on;
    var btn = $disc('#CartDrawer-DiscountApply');
    var input = $disc('#CartDrawer-DiscountInput');
    if (btn) {
      btn.disabled = on;
      btn.innerHTML = on ? '<span class="cdu-spinner"></span>' : 'Anwenden';
    }
    if (input) input.disabled = on;
  }

  function discShowPill(code) {
    var fb = $disc('#CartDrawer-DiscountFeedback');
    var txt = fb && fb.querySelector('.cdu-discount__feedback-text');
    var input = $disc('#CartDrawer-DiscountInput');
    if (fb) {
      fb.hidden = false;
      fb.className = 'cdu-discount__feedback cdu-discount__feedback--pill';
      if (txt) txt.innerHTML = '<svg class="icon icon-discount" viewBox="0 0 12 12" width="12" height="12"><path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"/></svg> ' + code.toUpperCase();
    }
    if (input) input.value = '';
  }

  function discShowError(msg, persistent) {
    var fb = $disc('#CartDrawer-DiscountFeedback');
    var txt = fb && fb.querySelector('.cdu-discount__feedback-text');
    var input = $disc('#CartDrawer-DiscountInput');
    var removeBtn = fb && fb.querySelector('.cdu-discount__feedback-remove');
    if (fb) {
      fb.hidden = false;
      fb.className = 'cdu-discount__feedback cdu-discount__feedback--error';
      if (txt) txt.textContent = '*' + (msg || 'Der eingegebene Code ist ung\u00FCltig.');
      if (removeBtn) removeBtn.style.display = 'none';
    }
    if (input) input.classList.add('cdu-discount__input--error');
    if (!persistent) {
      setTimeout(function () {
        if (fb) fb.hidden = true;
        if (input) input.classList.remove('cdu-discount__input--error');
      }, 4000);
    }
  }

  function discReset() {
    var fb = $disc('#CartDrawer-DiscountFeedback');
    var input = $disc('#CartDrawer-DiscountInput');
    var btn = $disc('#CartDrawer-DiscountApply');
    if (fb) { fb.hidden = true; fb.className = 'cdu-discount__feedback'; }
    if (input) { input.value = ''; input.disabled = false; input.classList.remove('cdu-discount__input--error'); }
    if (btn) { btn.disabled = false; btn.textContent = 'Anwenden'; }
  }

  function discApply() {
    if (_discountBusy || !window.CartDiscount) return;
    var input = $disc('#CartDrawer-DiscountInput');
    var code = input ? input.value.trim() : '';
    if (!code) return;

    _discountBusy = true;
    discSetLoading(true);
    window.CartDiscount.applyAndRefresh(code)
      .then(function (cart) {
        _discountBusy = false;
        discSetLoading(false);

        var codeEntry = null;
        if (cart.discount_codes) {
          for (var i = 0; i < cart.discount_codes.length; i++) {
            if (cart.discount_codes[i].code.toUpperCase() === code.toUpperCase()) {
              codeEntry = cart.discount_codes[i];
              break;
            }
          }
        }

        if (codeEntry && codeEntry.applicable) {
          discShowPill(code);
          setTimeout(function () { initShippingBar(); initShippingRow(); initDiscount(); }, 150);
        } else {
          // DEV-2026-0180: removeAndRefresh re-rendert den Drawer-DOM und wischt
          // die Fehlermeldung sofort weg — daher erst refreshen, DANN Meldung
          // persistent anzeigen. Ausblenden erst bei neuer Eingabe (input-Handler).
          var errMsg = codeEntry
            ? 'Produktbedingung nicht erf\u00FCllt.'
            : 'Der eingegebene Code ist ung\u00FCltig.';
          window.CartDiscount.removeAndRefresh()
            .catch(function () {})
            .then(function () {
              setTimeout(function () {
                initShippingBar();
                initShippingRow();
                initDiscount();
                discShowError(errMsg, true);
              }, 150);
            });
        }
      })
      .catch(function () {
        _discountBusy = false;
        discSetLoading(false);
        discShowError('Fehler bei der Validierung.');
      });
  }

  function discRemove() {
    if (_discountBusy || !window.CartDiscount) return;
    var fb = $disc('#CartDrawer-DiscountFeedback');
    if (fb) fb.hidden = true;

    _discountBusy = true;
    discSetLoading(true);
    window.CartDiscount.removeAndRefresh()
      .then(function () {
        discSetLoading(false);
        discReset();
        setTimeout(function () {
          _discountBusy = false;
          initShippingBar();
          initShippingRow();
          initDiscount();
        }, 300);
      })
      .catch(function () {
        _discountBusy = false;
        discSetLoading(false);
        discReset();
      });
  }

  function initDiscountDelegation() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.discDelegated) return;
    drawer.dataset.discDelegated = '1';

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('#CartDrawer-DiscountApply')) { e.preventDefault(); discApply(); }
      if (e.target.closest('#CartDrawer-DiscountRemove')) { e.preventDefault(); discRemove(); }
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.id === 'CartDrawer-DiscountInput') {
        e.preventDefault(); discApply();
      }
    });

    // DEV-2026-0180: Persistente Fehlermeldung erst ausblenden, wenn der
    // Kunde eine neue Eingabe beginnt
    drawer.addEventListener('input', function (e) {
      if (e.target.id === 'CartDrawer-DiscountInput') {
        var fb = $disc('#CartDrawer-DiscountFeedback');
        if (fb && fb.className.indexOf('--error') !== -1) {
          fb.hidden = true;
          fb.className = 'cdu-discount__feedback';
        }
        e.target.classList.remove('cdu-discount__input--error');
      }
    });
  }

  function initDiscount() {
    initDiscountDelegation();

    if (_discountBusy) return;
    var discountRow = document.querySelector('.cdu-totals__discount:not([data-discount-row])');
    if (discountRow && discountRow.textContent.trim()) {
      var codeTag = discountRow.querySelector('.cdu-totals__code-tag');
      if (codeTag) discShowPill(codeTag.textContent.trim());
    }
  }

  /* -------------------------------------------------------
     INIT + EVENT LISTENERS
     ------------------------------------------------------- */
  function initQtyGuard() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.qtyGuard) return;
    drawer.dataset.qtyGuard = '1';

    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.quantity__button');
      if (!qtyBtn) return;

      var wrapper = document.querySelector('cart-drawer .drawer__cart-items-wrapper');
      if (wrapper && !wrapper.querySelector('.cdu-cart-loading')) {
        var overlay = document.createElement('div');
        overlay.className = 'cdu-cart-loading';
        overlay.innerHTML = '<span class="cdu-spinner"></span>';
        wrapper.appendChild(overlay);
      }

      if (qtyBtn.getAttribute('name') === 'minus') {
        var qtyWrapper = qtyBtn.closest('.quantity');
        var input = qtyWrapper && qtyWrapper.querySelector('.quantity__input');
        if (input && parseInt(input.value, 10) <= 1) {
          e.preventDefault();
          e.stopPropagation();
          var cartItem = qtyBtn.closest('.cart-item');
          var removeBtn = cartItem && cartItem.querySelector('.cart-remove-button');
          if (removeBtn) removeBtn.click();
        }
      }
    }, true);
  }

  function initAll() {
    initShippingBar();
    initShippingRow();
    initDiscount();
    initQtyGuard();

    // Hinweis: Kein eigener MutationObserver hier — der bestehende Observer weiter unten
    // ruft initShippingRow() bereits nach Cart-Updates auf. Ein zweiter Observer mit
    // subtree:true fuehrt zur Endlos-Schleife, weil initShippingRow selbst textContent
    // schreibt und dadurch neue Mutations feuert.

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-checkout-url]');
      if (link) {
        try { sessionStorage.setItem('revolor_from_checkout', '1'); } catch (ex) {}
      }
    });

    try {
      if (sessionStorage.getItem('revolor_from_checkout') === '1') {
        sessionStorage.removeItem('revolor_from_checkout');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          setTimeout(function () { drawer.open(); }, 300);
        }
      }
    } catch (ex) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        initShippingBar();
        initShippingRow();
        initDiscount();
        observer.disconnect();
        attachObserver();
      }, 100);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === 'childList' && mutations[i].addedNodes.length > 0) {
        initShippingBar();
        initShippingRow();
        setTimeout(initDiscount, 100);
        break;
      }
    }
  });

  function attachObserver() {
    var drawerInner = document.querySelector('cart-drawer .drawer__inner');
    if (drawerInner) {
      observer.observe(drawerInner, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
